import { useState, createContext, useContext } from "react";

const ToggleRegionContext = createContext();

export function ToggleRegionProvider({ children }) {
    const [isRegionNa, setRegionNa] = useState(true); // if not NA, our region is Eu

    return (
        <ToggleRegionContext.Provider value={{ isRegionNa, updateRegion: setRegionNa }}>
            {children}
        </ToggleRegionContext.Provider>
    )
}

export const useToggleRegion = () => {
    const { isRegionNa, updateRegion } = useContext(ToggleRegionContext);
    return { isRegionNa, updateRegion }
}